export enum EntityProcedureEnum {
  ENTITY_PROCEDURE_CARD = 'entity-procedure-card',
  ENTITY_PROCEDURE_ACTIONS_PRICE = 'entity-procedure-actions--price',
  ENTITY_PROCEDURE_ACTIONS_INSTALLMENT = 'entity-procedure-actions--installment',
  ENTITY_PROCEDURE_ACTIONS_PRICE_BUTTON = 'entity-procedure-actions--price-button',
  ENTITY_PROCEDURE_ACTIONS_SEE_SCHEDULE_BUTTON = 'entity-procedure-actions-see-schedule-button',
  ENTITY_PROCEDURE_AVATAR = 'entity-procedure-avatar',
  ENTITY_PROCEDURE_PROFILE_PROFESSIONAL_NAME = 'entity-procedure-profile--professional-name',
  ENTITY_PROCEDURE_PROFILE_PARTNER_NAME = 'entity-procedure-profile--partner-name',
  ENTITY_PROCEDURE_TELEHEALTH_LABEL = 'entity-procedure-telehealth-label',
  ENTITY_PROCEDURE_PILL = 'entity-procedure-pill',
  ENTITY_PROCEDURE_PILL_ICON = 'entity-procedure-pill--icon',
  ENTITY_PROCEDURE_PILL_LABEL = 'entity-procedure-pill--label',
  ENTITY_PROCEDURE_PILL_ORIGINAL_PRICE = 'entity-procedure-pill--original-price',
  ENTITY_PROCEDURE_PILL_PRICE = 'entity-procedure-pill--price',
}
